import React from 'react';
import { motion } from 'framer-motion';
import usePerformanceOptimization from '../../hooks/usePerformanceOptimization';

const CleanCard = ({
  children,
  className = '',
  variant = 'default',
  hover = true,
  animate = true,
  ...props
}) => {
  const { shouldReduceAnimations, getOptimizedProps } = usePerformanceOptimization();
  
  const variants = {
    default: 'bg-card border border-border shadow-sm',
    primary: 'bg-card border border-brand-primary/20 shadow-sm',
    secondary: 'bg-secondary border border-border shadow-sm',
    accent: 'bg-card border border-brand-accent/20 shadow-sm',
    muted: 'bg-muted border border-border shadow-sm',
  };

  const cardVariants = {
    initial: {
      opacity: 0,
      y: shouldReduceAnimations ? 5 : 10
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceAnimations ? 0.15 : 0.3,
        ease: "easeOut"
      }
    },
    hover: {
      y: shouldReduceAnimations ? -1 : -2,
      transition: {
        duration: shouldReduceAnimations ? 0.1 : 0.2,
        ease: "easeOut"
      }
    }
  };

  const shouldAnimate = animate && !shouldReduceAnimations;
  const shouldHover = hover && !shouldReduceAnimations;

  return (
    <motion.div
      className={`
        ${variants[variant]}
        rounded-lg p-6
        ${hover ? 'cursor-pointer hover:shadow-md' : ''}
        transition-shadow duration-200
        ${className}
      `}
      {...getOptimizedProps({
        variants: shouldAnimate ? cardVariants : {},
        initial: shouldAnimate ? "initial" : false,
        animate: shouldAnimate ? "animate" : false,
        whileHover: shouldHover ? "hover" : false
      })}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default CleanCard;
